/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseModule } from '../../models/api-response-module';
import { Module } from '../../models/module';

export interface CreateModule$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Module
}

export function createModule(http: HttpClient, rootUrl: string, params: CreateModule$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseModule>> {
  const rb = new RequestBuilder(rootUrl, createModule.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseModule>;
    })
  );
}

createModule.PATH = '/v1/api/admin-ui/module';
